/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Archive_Description_UnrealInputs */

const fr_vehicle_action_archive_description_unreal = /** @type {(inputs: Vehicle_Action_Archive_Description_UnrealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`il ne correspond pas à un réel véhicule du réseau.`)
};

const en_vehicle_action_archive_description_unreal = /** @type {(inputs: Vehicle_Action_Archive_Description_UnrealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`it does not match a real vehicle on the network.`)
};

/**
* | output |
* | --- |
* | "it does not match a real vehicle on the network." |
*
* @param {Vehicle_Action_Archive_Description_UnrealInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_archive_description_unreal = /** @type {((inputs?: Vehicle_Action_Archive_Description_UnrealInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Archive_Description_UnrealInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_archive_description_unreal(inputs)
	return en_vehicle_action_archive_description_unreal(inputs)
});